import { render, staticRenderFns } from "./Bottles.vue?vue&type=template&id=110da25c&scoped=true"
import script from "./Bottles.vue?vue&type=script&lang=js"
export * from "./Bottles.vue?vue&type=script&lang=js"
import style0 from "./Bottles.vue?vue&type=style&index=0&id=110da25c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110da25c",
  null
  
)

export default component.exports